import * as React from "react";

function SvgBuisnessMgmt({ title, titleId, ...props }) {
  return (
    <>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby={titleId}
        {...props}
      >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
          d="M19.92 29.144h-2.502c-.229-.01-.35-.138-.343-.362a.314.314 0 01.343-.33c.566-.004 1.132 0 1.7-.004h.8v-.993c.012-1.118.748-1.851 1.865-1.855h2.379v-2.115c-.107-.006-.212-.018-.32-.018-.71 0-1.42.005-2.132 0-1.016-.012-1.777-.748-1.79-1.762a92.44 92.44 0 010-2.865c.016-1.017.77-1.757 1.785-1.768.81-.008 1.619 0 2.453 0v-2.136c-.83 0-1.65.007-2.468 0-.819-.007-1.611-.51-1.678-1.292a22.748 22.748 0 010-3.813c.065-.77.853-1.283 1.647-1.287 1.91-.01 3.82-.01 5.732 0a1.732 1.732 0 011.75 1.73c.019.976.019 1.954 0 2.932a1.747 1.747 0 01-1.753 1.73c-.8.012-1.6.005-2.399.007a.378.378 0 00-.084.027v2.101h2.274c1.253 0 1.966.712 1.969 1.958 0 .856.005 1.711 0 2.566-.008 1.139-.745 1.87-1.88 1.876H24.91v2.137h1.394c.378 0 .756-.01 1.133 0a1.748 1.748 0 011.704 1.667c.017.364 0 .728 0 1.093 1.048-.05 2.026-1.049 2.123-2.136a5.03 5.03 0 00.015-.432V5.232l-.296.278a3.197 3.197 0 01-1.967.88c-.248.022-.513.039-.56-.308-.037-.262.122-.38.511-.41.956-.076 1.661-.554 2.069-1.409.408-.855.335-1.712-.212-2.492A2.364 2.364 0 0028.91.724c-.11 0-.222-.006-.333-.006C20.19.718 11.803.716 3.415.713c-.824 0-1.53.226-2.083.852-.372.42-.612.914-.6 1.478.017.873-.032 1.77.15 2.613.362 1.665 1.942 2.863 3.648 2.871 3.433.015 6.866.007 10.298 0a2.403 2.403 0 001.716-.698c.384-.369.759-.748 1.133-1.128a3.312 3.312 0 012.452-1.02h7.065c.098 0 .224-.014.29.037.102.08.235.217.226.318-.012.122-.137.26-.25.338-.075.054-.214.023-.325.023-2.31 0-4.62.008-6.93 0-.815-.005-1.496.26-2.06.847-.323.336-.662.658-.989.99a3.274 3.274 0 01-2.418 1.014c-3.356.005-6.711.013-10.065 0C3.12 9.24 1.86 8.605.917 7.362a18.268 18.268 0 00-.177-.23c-.01.17-.02.275-.02.379v18.261c0 1.646 1.036 2.676 2.69 2.676h12.262c.111 0 .223 0 .334.004.21.01.331.12.334.334.005.23-.117.348-.345.356H3.33c-1.608 0-2.854-.935-3.225-2.413a3.735 3.735 0 01-.102-.89c-.005-7.508-.005-15.017 0-22.526C.004 1.38 1.389 0 3.326 0h25.362c1.92 0 3.308 1.38 3.31 3.293.003 7.52.003 15.04 0 22.56 0 1.627-1.013 2.878-2.595 3.21-.21.044-.267.136-.257.334.012.3.01.6 0 .9a1.743 1.743 0 01-1.724 1.691c-1.922.014-3.844.014-5.766 0a1.74 1.74 0 01-1.73-1.717c-.01-.35-.005-.705-.005-1.127zm4.616-19.89h-2.764c-.711 0-1.142.432-1.15 1.14-.008.89-.006 1.78 0 2.665.007.73.434 1.157 1.167 1.157 1.833.005 3.664.005 5.496 0 .734 0 1.155-.424 1.166-1.157.007-.876.007-1.753 0-2.63-.005-.751-.431-1.171-1.184-1.174-.913-.005-1.823-.002-2.731-.002zm.023 8.53h-2.732c-.774 0-1.2.42-1.205 1.186-.006.866-.006 1.732 0 2.598.004.753.426 1.178 1.178 1.18 1.821.003 3.642.003 5.462 0 .758 0 1.183-.42 1.189-1.169.007-.877.007-1.755 0-2.631-.006-.734-.432-1.157-1.16-1.163-.914-.004-1.824 0-2.735 0h.003zm-.017 13.496h2.732c.751 0 1.17-.424 1.174-1.181.007-.866.007-1.732 0-2.599 0-.754-.426-1.18-1.174-1.182-1.821-.004-3.642-.004-5.463 0-.77 0-1.188.423-1.192 1.199-.004.854-.004 1.709 0 2.564 0 .776.421 1.197 1.192 1.2h2.731z"
          fill="url(#buisnessMgmt_svg__paint0_linear_3_2226)"
        />
        <path
          d="M8.538 24.628c-.316-.136-.608-.267-.907-.384a.296.296 0 00-.229.04 1.67 1.67 0 00-.239.23c-.578.571-1.163.571-1.74 0-.284-.282-.57-.562-.847-.848-.48-.497-.5-1.124.013-1.587.323-.293.43-.546.17-.914a.764.764 0 01-.107-.279c-.044-.212-.162-.293-.377-.267a2.424 2.424 0 01-.432 0 1.029 1.029 0 01-.978-.991c-.018-.499-.015-1 0-1.5.015-.605.46-1.078 1.066-1.038.492.033.706-.132.876-.587.136-.368.127-.572-.168-.841-.56-.511-.546-1.122-.022-1.657a42.7 42.7 0 01.896-.894c.485-.467 1.12-.493 1.562 0 .31.346.557.367.978.19.392-.166.521-.347.503-.762-.032-.704.423-1.135 1.132-1.144.444-.005.888-.008 1.332 0 .635.014 1.095.44 1.06 1.072-.026.477.125.686.574.856.378.144.589.14.868-.168.5-.55 1.126-.528 1.66 0 .292.289.584.577.87.872.486.5.49 1.093.015 1.596a1.586 1.586 0 01-.213.211c-.192.14-.145.276-.084.482.167.557.423.849 1.08.79.5-.047.906.444.934.99.026.5.026 1 0 1.499-.03.615-.47 1.057-1.087 1.015-.485-.032-.675.143-.851.578-.156.385-.128.593.173.868.543.5.533 1.113.02 1.634-.297.302-.595.6-.896.895-.495.481-1.13.505-1.587 0-.29-.32-.542-.439-.913-.178a.548.548 0 01-.216.084c-.285.05-.364.22-.338.494.09.964-.552 1.402-1.35 1.343-.343-.024-.689 0-1.033-.005-.727-.012-1.155-.445-1.162-1.168-.008-.182-.006-.358-.006-.527zm7.186-9.763c-.05-.116-.067-.213-.123-.267a26.47 26.47 0 00-1.036-1.035c-.163-.154-.35-.114-.506.038-.183.178-.367.356-.542.542-.174.186-.355.206-.595.09-.388-.187-.79-.346-1.195-.496-.23-.084-.348-.215-.341-.463.007-.249 0-.511 0-.767 0-.255-.132-.405-.385-.412-.456-.01-.911-.01-1.367 0-.25.007-.38.153-.378.41.002.258 0 .511 0 .767 0 .255-.118.38-.348.465-.414.154-.823.323-1.225.51-.227.104-.4.073-.567-.103a16.437 16.437 0 00-.542-.542c-.187-.179-.373-.178-.556 0-.317.312-.63.626-.943.943-.193.194-.183.39.009.58.173.173.342.35.519.518.177.168.215.356.1.595-.187.39-.349.79-.496 1.196-.09.243-.231.364-.491.356-.233-.006-.466.005-.7 0-.305-.01-.457.133-.459.436v1.266c0 .285.156.427.438.43.245 0 .49.009.733 0 .245-.009.386.1.472.331.156.414.322.825.508 1.226.105.226.082.4-.095.568-.178.168-.346.346-.52.518-.202.199-.215.401-.01.607.307.307.61.615.92.918.193.19.392.183.584-.004.178-.171.356-.34.518-.52.163-.178.361-.208.598-.098.39.182.79.348 1.196.495.245.089.361.236.355.492-.006.256 0 .489 0 .733 0 .267.129.416.403.417h1.3c.295 0 .423-.159.428-.436 0-.245.008-.49 0-.734-.008-.243.1-.382.332-.469.415-.153.824-.325 1.227-.507.223-.101.4-.089.569.094.169.184.346.347.517.52.203.203.404.207.608 0 .296-.297.595-.596.896-.895.218-.217.2-.425-.013-.633-.178-.17-.344-.348-.519-.518-.175-.17-.178-.334-.082-.544.177-.403.355-.811.508-1.225.089-.23.212-.35.464-.341.251.009.51.007.766 0 .255-.007.405-.124.408-.385.007-.454.006-.91 0-1.366 0-.238-.132-.371-.374-.375-.241-.005-.49-.015-.733 0-.307.015-.473-.125-.55-.415a4.618 4.618 0 00-.22-.623c-.374-.872-.375-.87.281-1.552.092-.106.176-.219.254-.336z"
          fill="url(#buisnessMgmt_svg__paint1_linear_3_2226)"
        />
        <path
          d="M2.856 4.61a1.776 1.776 0 011.78-1.766A1.77 1.77 0 016.4 4.626a1.777 1.777 0 01-1.78 1.767A1.77 1.77 0 012.988 5.29a1.777 1.777 0 01-.132-.68zm2.827.024A1.069 1.069 0 004.64 3.558a1.083 1.083 0 00-1.084 1.077 1.063 1.063 0 001.066 1.048 1.039 1.039 0 001.061-1.05h-.001z"
          fill="url(#buisnessMgmt_svg__paint2_linear_3_2226)"
        />
        <path
          d="M7.121 4.603a1.776 1.776 0 011.787-1.76 1.77 1.77 0 011.757 1.79 1.777 1.777 0 01-1.787 1.76 1.77 1.77 0 01-1.757-1.79zm2.827.019a1.069 1.069 0 00-1.055-1.068 1.083 1.083 0 00-1.07 1.057 1.062 1.062 0 001.08 1.068 1.037 1.037 0 001.048-1.057h-.003z"
          fill="url(#buisnessMgmt_svg__paint3_linear_3_2226)"
        />
        <path
          d="M11.386 4.606a1.776 1.776 0 011.784-1.762 1.77 1.77 0 011.76 1.786 1.778 1.778 0 01-1.105 1.632 1.77 1.77 0 01-2.438-1.656zm2.828.024a1.07 1.07 0 00-1.047-1.073 1.084 1.084 0 00-1.079 1.048 1.062 1.062 0 001.076 1.078 1.04 1.04 0 001.053-1.053h-.003z"
          fill="url(#buisnessMgmt_svg__paint4_linear_3_2226)"
        />
        <path
          d="M24.508 12.085h-2.73c-.225 0-.411-.059-.433-.31-.024-.284.15-.391.416-.39H27.29c.318 0 .504.196.43.438-.068.22-.242.261-.444.26l-2.767.002z"
          fill="url(#buisnessMgmt_svg__paint5_linear_3_2226)"
        />
        <path
          d="M23.092 10.67h-1.297c-.255 0-.451-.076-.452-.361 0-.268.188-.357.427-.357h2.692c.238 0 .42.09.416.364-.004.274-.178.356-.424.351l-1.362.003z"
          fill="url(#buisnessMgmt_svg__paint6_linear_3_2226)"
        />
        <path
          d="M24.502 20.618h-2.73c-.263 0-.445-.094-.428-.38.017-.287.221-.322.455-.321h2.964c.844 0 1.689-.007 2.531.009a.598.598 0 01.384.19c.055.06.047.274-.012.324a.744.744 0 01-.433.17c-.91.016-1.821.01-2.73.008z"
          fill="url(#buisnessMgmt_svg__paint7_linear_3_2226)"
        />
        <path
          d="M23.101 19.204h-1.333c-.244 0-.422-.09-.429-.35-.006-.262.178-.365.418-.366h2.691c.237 0 .425.08.426.356 0 .293-.194.364-.444.362-.443-.005-.886-.002-1.329-.002z"
          fill="url(#buisnessMgmt_svg__paint8_linear_3_2226)"
        />
        <path
          d="M24.502 29.142h-2.733c-.266 0-.444-.097-.425-.383.018-.287.224-.32.457-.318h5.467c.25 0 .46.056.46.35 0 .293-.21.355-.46.355-.922-.004-1.842-.004-2.766-.004z"
          fill="url(#buisnessMgmt_svg__paint9_linear_3_2226)"
        />
        <path
          d="M23.085 27.73H21.79c-.258 0-.45-.083-.444-.367 0-.267.195-.35.432-.35h2.692c.24 0 .417.097.41.37-.007.271-.188.347-.429.346l-1.366.001z"
          fill="url(#buisnessMgmt_svg__paint10_linear_3_2226)"
        />
        <path
          d="M10.094 15.65c1.93.02 3.254 1.262 3.41 2.982.023.26.021.508-.31.561-.24.038-.371-.134-.395-.49-.088-1.37-1.28-2.44-2.615-2.345-1.387.1-2.452 1.278-2.357 2.605.102 1.42 1.268 2.464 2.666 2.36.812-.059 1.449-.444 1.912-1.12.072-.106.171-.24.278-.26.107-.02.314.037.368.126a.48.48 0 010 .418 2.968 2.968 0 01-1.787 1.406c-1.308.374-2.458.063-3.35-.958-.892-1.021-1.047-2.198-.494-3.418.553-1.22 1.567-1.819 2.674-1.867z"
          fill="url(#buisnessMgmt_svg__paint11_linear_3_2226)"
        />
        <defs>
          <linearGradient
            id="buisnessMgmt_svg__paint0_linear_3_2226"
            x1={-6}
            y1={16.171}
            x2={37.6}
            y2={16.171}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="currentColor" />
            <stop offset={1} stopColor="#00007E" />
          </linearGradient>
          <linearGradient
            id="buisnessMgmt_svg__paint1_linear_3_2226"
            x1={0.05}
            y1={18.942}
            x2={20.42}
            y2={18.942}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="currentColor" />
            <stop offset={1} stopColor="#00007E" />
          </linearGradient>
          <linearGradient
            id="buisnessMgmt_svg__paint2_linear_3_2226"
            x1={2.192}
            y1={4.637}
            x2={7.02}
            y2={4.637}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="currentColor" />
            <stop offset={1} stopColor="#00007E" />
          </linearGradient>
          <linearGradient
            id="buisnessMgmt_svg__paint3_linear_3_2226"
            x1={6.457}
            y1={4.637}
            x2={11.285}
            y2={4.637}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="currentColor" />
            <stop offset={1} stopColor="#00007E" />
          </linearGradient>
          <linearGradient
            id="buisnessMgmt_svg__paint4_linear_3_2226"
            x1={10.722}
            y1={4.637}
            x2={15.55}
            y2={4.637}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="currentColor" />
            <stop offset={1} stopColor="#00007E" />
          </linearGradient>
          <linearGradient
            id="buisnessMgmt_svg__paint5_linear_3_2226"
            x1={20.145}
            y1={11.739}
            x2={28.854}
            y2={11.739}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="currentColor" />
            <stop offset={1} stopColor="#00007E" />
          </linearGradient>
          <linearGradient
            id="buisnessMgmt_svg__paint6_linear_3_2226"
            x1={20.68}
            y1={10.315}
            x2={25.496}
            y2={10.315}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="currentColor" />
            <stop offset={1} stopColor="#00007E" />
          </linearGradient>
          <linearGradient
            id="buisnessMgmt_svg__paint7_linear_3_2226"
            x1={20.148}
            y1={20.272}
            x2={28.83}
            y2={20.272}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="currentColor" />
            <stop offset={1} stopColor="#00007E" />
          </linearGradient>
          <linearGradient
            id="buisnessMgmt_svg__paint8_linear_3_2226"
            x1={20.676}
            y1={18.851}
            x2={25.493}
            y2={18.851}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="currentColor" />
            <stop offset={1} stopColor="#00007E" />
          </linearGradient>
          <linearGradient
            id="buisnessMgmt_svg__paint9_linear_3_2226"
            x1={20.145}
            y1={28.797}
            x2={28.845}
            y2={28.797}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="currentColor" />
            <stop offset={1} stopColor="#00007E" />
          </linearGradient>
          <linearGradient
            id="buisnessMgmt_svg__paint10_linear_3_2226"
            x1={20.683}
            y1={27.376}
            x2={25.499}
            y2={27.376}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="currentColor" />
            <stop offset={1} stopColor="#00007E" />
          </linearGradient>
          <linearGradient
            id="buisnessMgmt_svg__paint11_linear_3_2226"
            x1={5.895}
            y1={18.882}
            x2={14.635}
            y2={18.882}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="currentColor" />
            <stop offset={1} stopColor="#00007E" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
}

export default SvgBuisnessMgmt;
